import apiDivision from '@/api/division'
export default [
  {
    path: '/divisions',
    name: 'division',
    meta: { requiresAuth: true },
    component: () => import('@/pages/division/index.vue')
  },
  {
    path: '/divisions/:id',
    name: 'division-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/division/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiDivision.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
